import React from "react";
import { MenuItem, NavDropdown, Navbar, Nav, NavItem } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { isRestricted } from "../../../store/utility";
//import { isA, isCA } from "../../../store/utility";
/*import {Link} from 'react-router-dom';*/
import classes from './Header.css';
const atisEstAdmin = () => {
  try {
    const t = localStorage.getItem("token");
    if (!t) return false;
    const p = t.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(atob(p + "===".slice((p.length + 3) % 4))).role === "ADMIN";
  } catch (e) {
    return false;
  }
};

class Header extends React.Component {
  state = { nbRecues: 0, nbMaint: 0, teleVisible: false, nbTele: 0 };

  componentDidMount() {
    this.majTele(); // TELERELEVE-3110
    if (!atisEstAdmin()) return;
    this.majRecues();
    this.timerRecues = setInterval(this.majRecues, 60000);
    this.majMaint();
    this.timerMaint = setInterval(this.majMaint, 300000);
  }

  componentWillUnmount() {
    clearInterval(this.timerRecues);
    clearInterval(this.timerMaint);
  }

  majRecues = () => {
    const token = localStorage.getItem("token");
    if (!token) return;
    fetch("/__recues/api/compteur", { headers: { Authorization: "Bearer " + token } })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (d) this.setState({ nbRecues: d.a_traiter || 0 });
      })
      .catch(() => {});
  };

  // MAINTENANCE-1910 : nombre d'echeances de maintenance a creer
  majMaint = () => {
    const token = localStorage.getItem("token");
    if (!token) return;
    fetch("/__maintenance/api/compteur", { headers: { Authorization: "Bearer " + token } })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (d) this.setState({ nbMaint: d.a_creer || 0 });
      })
      .catch(() => {});
  };

  // TELERELEVE-3110 : bouton Relevés (sites de télérelève du compte ; points à valider pour un admin)
  majTele = () => {
    const token = localStorage.getItem("token");
    if (!token) return;
    fetch("/__telereleve/api/compteur", { headers: { Authorization: "Bearer " + token } })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (d) this.setState({ teleVisible: !!d.visible, nbTele: d.a_valider || 0 });
      })
      .catch(() => {});
  };

  render() {
    return (
      <header className="topnavbar-wrapper">
        <Navbar
          className="navbar topnavbar"
          fluid={true}
          fixedTop={true}
          staticTop={true}
        >
          <Navbar.Header>
            <Navbar.Brand>
              <a href={null}>
                <div className="brand-logo">
                  <img
                    src={require("../../../img/logo-atis-app.png")}
                    alt="Logo Atis"
                    className="img-responsive"
                  />
                </div>
              </a>
            </Navbar.Brand>
            <Navbar.Toggle />
            {atisEstAdmin() ? (
              <a href="/__recues/" className={"visible-xs-block atis-recues-xs" + (this.state.nbRecues > 0 ? " actif" : "")}>
                <i className="fa fa-inbox" /> {"Re\u00e7ues"}
                {this.state.nbRecues > 0 ? <span className="nb">{this.state.nbRecues}</span> : null}
              </a>
            ) : null}
            {/* ATIS-HABILLAGE-A 01/11/2026 : raccourci Planning (iPhone) */}
            {atisEstAdmin() && process.env.REACT_APP_ATIS_PLANNING_URL ? (
              <a href={process.env.REACT_APP_ATIS_PLANNING_URL} target="_blank" rel="noopener noreferrer" className="visible-xs-block atis-planning-xs">
                <i className="fa fa-calendar" /> Planning
              </a>
            ) : null}
          </Navbar.Header>
          <Navbar.Collapse>
            <Nav>
              <LinkContainer to="/requests">
                <NavItem><i className="fa fa-calendar-check-o" /><span className="text-nav">Interventions</span></NavItem>
              </LinkContainer>
              { atisEstAdmin() ? (
                <NavItem href="/__recues/">
                  <style>{"@keyframes atisPulse{0%,100%{box-shadow:0 0 0 0 rgba(255,80,40,.75)}50%{box-shadow:0 0 0 7px rgba(255,80,40,0)}}"}</style>
                  <span
                    style={{
                      background: this.state.nbRecues > 0 ? "#e8590c" : "rgba(255,255,255,0.2)",
                      color: "#fff",
                      borderRadius: 6,
                      padding: "6px 12px",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                      animation: this.state.nbRecues > 0 ? "atisPulse 1.6s ease-in-out infinite" : "none",
                    }}
                  >
                    <i className="fa fa-inbox" /> Demandes reçues
                    {this.state.nbRecues > 0 ? (
                      <span
                        style={{
                          background: "#d00000",
                          color: "#fff",
                          borderRadius: 10,
                          padding: "1px 8px",
                          marginLeft: 8,
                          fontSize: 13,
                          fontWeight: 700,
                        }}
                      >
                        {this.state.nbRecues}
                      </span>
                    ) : null}
                  </span>
                </NavItem>
              ) : null}
              { atisEstAdmin() ? (
                <NavItem href="/__maintenance/">
                  <span
                    style={{
                      background: "rgba(255,255,255,0.2)",
                      color: "#fff",
                      borderRadius: 6,
                      padding: "6px 12px",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                    }}
                  >
                    <i className="fa fa-wrench" /> Maintenance
                    {this.state.nbMaint > 0 ? (
                      <span
                        style={{
                          background: "#e8590c",
                          color: "#fff",
                          borderRadius: 10,
                          padding: "1px 8px",
                          marginLeft: 8,
                          fontSize: 13,
                          fontWeight: 700,
                        }}
                      >
                        {this.state.nbMaint}
                      </span>
                    ) : null}
                  </span>
                </NavItem>
              ) : null}
              { this.state.teleVisible ? (
                <NavItem href="/__telereleve/">
                  <span
                    style={{
                      background: "rgba(255,255,255,0.2)",
                      color: "#fff",
                      borderRadius: 6,
                      padding: "6px 12px",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                    }}
                  >
                    <i className="fa fa-tachometer" /> {"Relev\u00e9s"}
                    {this.state.nbTele > 0 ? (
                      <span
                        style={{
                          background: "#e8590c",
                          color: "#fff",
                          borderRadius: 10,
                          padding: "1px 8px",
                          marginLeft: 8,
                          fontSize: 13,
                          fontWeight: 700,
                        }}
                      >
                        {this.state.nbTele}
                      </span>
                    ) : null}
                  </span>
                </NavItem>
              ) : null}
              { !isRestricted() ? (
                <LinkContainer to="/documents">
                  <NavItem>
                    <i className="fa fa-folder-open" />
                    <span className="text-nav">Documents</span>
                  </NavItem>
                </LinkContainer>
              ): null}
              { !isRestricted() ? (
                <LinkContainer to="/settings">
                  
                  <NavItem>
                    <i className="fa fa-cogs" />
                    <span className="text-nav">Paramètres</span>
                  </NavItem>
                </LinkContainer>
              ) : null}
              {/*isA() || isCA() ? (<LinkContainer to="/users" ><NavItem><i className="fa fa-users"></i>&nbsp;Utilisateurs</NavItem></LinkContainer>) : ""*/}
              {/*isA() ? (<LinkContainer to="/companies" ><NavItem><i className="fa fa-building"></i>&nbsp;Sociétés</NavItem></LinkContainer>) : ""*/}
            </Nav>
            <Nav pullRight>
              {/* ATIS-HABILLAGE-A 01/11/2026 : raccourci Planning (PC) */}
              {atisEstAdmin() && process.env.REACT_APP_ATIS_PLANNING_URL ? (
                <NavItem className="atis-planning hidden-xs" href={process.env.REACT_APP_ATIS_PLANNING_URL} target="_blank" rel="noopener noreferrer">
                  <i className="fa fa-calendar" /><span className="text-nav">Planning</span>
                </NavItem>
              ) : null}
              <NavDropdown
                noCaret
                id="userDropDown"
                title={<i className="fa fa-user-circle fa-2x" />}
              >
                {/*<LinkContainer to="/account"><DropdownItem eventKey={ 3.1 }><i className="fa fa-gear fa-fw"></i>Mon compte</DropdownItem></LinkContainer>
                                <DropdownItem eventKey={ 3.1 }><i className="fa fa-building fa-fw"></i>Ma société</DropdownItem>
                                <DropdownItem divider />*/}
                <LinkContainer to="/logout">
                  <MenuItem>
                    <i className="fa fa-sign-out fa-fw text-nav-item" />
                    <span className="text-nav-item">D&eacute;connexion</span>
                  </MenuItem>
                </LinkContainer>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </header>
    );
  }
}
export default Header;



// WEBPACK FOOTER //
// ./src/components/Navigation/Header/Header.js